module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBox),
      expression: "showBox"
    }],
    staticClass: "img_preview"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "back_desc",
    on: {
      "click": _vm.hideBox
    }
  }, [_c('img', {
    attrs: {
      "src": "//img.58cdn.com.cn/m58/img/pointer_left.png"
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "picture_div"
  }, [_c('img', {
    staticClass: "picture",
    class: _vm.imgClass,
    attrs: {
      "src": _vm.imgUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "change_img",
    on: {
      "click": _vm.changeImg
    }
  }, [_c('span', [_vm._v("更换头像")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_div"
  }, [_c('span', {
    staticClass: "preview_title"
  }, [_vm._v("简历头像")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71370792","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/basic/headPortrait/preview.vue
// module id = 361
// module chunks = 0